import { Fragment, useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { LoadingButton } from '@mui/lab';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Link, Typography } from '@mui/material';
import classes from './style';
import dayjs from 'dayjs';
import api from '../../services/apiClient';
import {
  bloodTypeOptions,
  classTypeOptions,
  countryOptions,
  parqAnswersOptions,
  genderRange,
  getInitialParticipantState,
  idTypeCats,
  relationOptions,
  healthAnswerOptions,
  redBullParq2,
  redBullParq1,
  idTypeCatsDomestic,
  userTypeOptions,
  prodiOptions,
  yearOptions,
  ageRangeOpts,
  parqYesNo,
} from '../../controllers/DetailParticipants';
import { FormTextField } from '..';

const DetailParticipants = ({
  eventId,
  showDialog,
  closeDialog,
  goToSummary,
  kidsLimit,
  adultsLimit,
  kidMaxAge,
  participantLimit,
  adultMinAge,
  adultMaxAge,
  kidSizeRange,
  adultSizeRange,
  maxAllowedDate,
  isAllSos,
  isGroup,
  includeJersey,
  sizeChartUrl,
  categoryId,
  sizesInfo = [],
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [participants, setParticipants] = useState([]);
  const dialogContentRef = useRef(null);

  const isWHM = eventId === 91 || eventId === 90;

  const [email, setEmail] = useState({
    email: {
      value: '',
      errorMessage: '',
    },
  });
  const [team, setTeam] = useState({
    name: {
      value: '',
      errorMessage: '',
    },
  });
  const [emergency, setEmergency] = useState({
    person: { value: '', errorMessage: '' },
    contact: { value: '', errorMessage: '' },
    relation: { value: '', errorMessage: '' },
    runningFor: { value: '', errorMessage: '' },
    parq1: { value: '', errorMessage: '' },
    parq2: { value: '', errorMessage: '' },
    parq3: { value: '', errorMessage: '' },
    parq4: { value: '', errorMessage: '' },
    parq5: { value: '', errorMessage: '' },
    parq6: { value: '', errorMessage: '' },
    parq7: { value: '', errorMessage: '' },
    parq8: { value: '', errorMessage: '' },
  });
  const [checkLimitLoad, setCheckLimitLoad] = useState(false);

  const getFormLabel = (eventId) => {
    if (eventId !== 90 && eventId !== 91) {
      return {
        email: 'E-mail',
        name: 'Name (Sesuai ID)',
        gender: 'Gender',
        nationality: 'Nationality',
        idType: 'Id Type',
        idNumber: 'Id Number',
        birthDate: 'Birth Date',
        bloodType: 'Blood Type',
        phoneNumber: 'Phone Number',
        org: 'Organization / Community',
        size: 'Size',
        emgPerson: 'Person Name',
        emgContact: 'Person Contact',
        emgRelation: 'Person Relation',
        status: 'User Type',
        prodi: 'Study Program',
        year: 'Academic Year',
        ageRange: 'Age',
        parq: 'Yes/No',
        answer: 'Answer',
        acara: 'Event Option',
      };
    }

    return {
      email: 'Email',
      name: 'Nama',
      gender: 'Jenis Kelamin',
      nationality: 'Kebangsaan',
      idType: 'Jenis Identitas',
      idNumber: 'Nomor Identitas',
      birthDate: 'Tanggal Lahir',
      bloodType: 'Golongan Darah',
      phoneNumber: 'Nomor Kontak',
      org: 'Organisasi / Komunitas',
      size: 'Ukuran',
      emgPerson: 'Nama',
      emgContact: 'Kontak',
      emgRelation: 'Hubungan',
      status: 'Jenis Peserta',
      prodi: 'Program Studi',
      year: 'Tahun Ajaran',
      ageRange: 'Usia',
      parq: 'Yes/No',
      answer: 'Jawaban',
      acara: 'Pilihan Acara',
    };
  };

  const [currentPage, setCurrentPage] = useState();
  const [showSizeChart, setShowSizeChart] = useState(false);
  useEffect(() => {
    //   console.log(`kidsLimit : ${kidsLimit},
    // adultsLimit : ${adultsLimit},
    // kidMaxAge : ${kidMaxAge},
    // participantLimit : ${participantLimit},
    // adultMinAge : ${adultMinAge},
    // kidSizeRange : ${kidSizeRange},
    // adultSizeRange : ${adultSizeRange},
    // isAllSos : ${isAllSos},
    // isGroup : ${isGroup},
    // includeJersey : ${includeJersey}`);
    const list = getInitialParticipantState(
      undefined,
      isAllSos,
      kidsLimit,
      adultsLimit,
      participantLimit,
      kidSizeRange,
      adultSizeRange,
      sizesInfo,
      eventId,
    );
    setParticipants(list);
    setEmergency({
      person: { value: '', errorMessage: '' },
      contact: { value: '', errorMessage: '' },
      relation: { value: '', errorMessage: '' },
      runningFor: { value: '', errorMessage: '' },
      parq1: { value: '', errorMessage: '' },
      parq2: { value: '', errorMessage: '' },
      parq3: { value: '', errorMessage: '' },
      parq4: { value: '', errorMessage: '' },
      parq5: { value: '', errorMessage: '' },
      parq6: { value: '', errorMessage: '' },
      parq7: { value: '', errorMessage: '' },
      parq8: { value: '', errorMessage: '' },
    });
    setTeam({
      name: {
        value: '',
        errorMessage: '',
      },
    });
    setEmail({
      email: {
        value: '',
        errorMessage: '',
      },
    });
  }, [
    isAllSos,
    isGroup,
    kidsLimit,
    adultsLimit,
    participantLimit,
    kidSizeRange,
    adultSizeRange,
    sizesInfo,
  ]);

  useEffect(() => {
    if (!showDialog) return;

    requestAnimationFrame(() => {
      dialogContentRef.current?.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    });
  }, [currentPage, showDialog]);

  useEffect(() => {
    if (!showDialog) return;
    const list = getInitialParticipantState(
      undefined,
      isAllSos,
      kidsLimit,
      adultsLimit,
      participantLimit,
      kidSizeRange,
      adultSizeRange,
      sizesInfo,
      eventId,
    );
    setParticipants(list);
    setEmergency({
      person: { value: '', errorMessage: '' },
      contact: { value: '', errorMessage: '' },
      relation: { value: '', errorMessage: '' },
      runningFor: { value: '', errorMessage: '' },
      parq1: { value: '', errorMessage: '' },
      parq2: { value: '', errorMessage: '' },
      parq3: { value: '', errorMessage: '' },
      parq4: { value: '', errorMessage: '' },
      parq5: { value: '', errorMessage: '' },
      parq6: { value: '', errorMessage: '' },
      parq7: { value: '', errorMessage: '' },
      parq8: { value: '', errorMessage: '' },
    });
    setTeam({
      name: {
        value: '',
        errorMessage: '',
      },
    });
    setEmail({
      email: {
        value: '',
        errorMessage: '',
      },
    });
    setCurrentPage(0);
  }, [showDialog]);

  const handleDataChange = (value, key, index) => {
    // console.log(value);
    // console.log(key);
    // console.log(index);
    const updatedDP = [...participants];

    if (!!updatedDP[index][key]?.errorMessage)
      updatedDP[index][key].errorMessage = '';

    updatedDP[index][key].value = value;

    setParticipants(updatedDP);
  };

  const handleEmergencyDataChange = (value, key) => {
    const updatedEmergency = { ...emergency };

    if (!!updatedEmergency[key]?.errorMessage)
      updatedEmergency[key].errorMessage = '';

    updatedEmergency[key].value = value;

    setEmergency(updatedEmergency);
  };

  const handleTeamNameChange = (value, key) => {
    const updated = { ...team };
    if (!!updated[key]?.errorMessage) updated[key].errorMessage = '';
    updated[key].value = value;
    setTeam(updated);
  };

  const handleEmailChange = (value, key) => {
    const updated = { ...email };
    if (!!updated[key]?.errorMessage) updated[key].errorMessage = '';
    updated[key].value = value;
    setEmail(updated);
  };

  const handleCloseDialog = () => {
    // setTeamName({
    //   value: '',
    //   errorMessage: '',
    // });

    // setEmergency({
    //   person: { value: '', errorMessage: '' },
    //   contact: { value: '', errorMessage: '' },
    //   relation: { value: '', errorMessage: '' },
    // });

    // const list = getInitialParticipantState(
    //   { firstName: 'hartz', lastName: 'Lie' },
    //   false,
    //   0,
    //   2,
    //   0,
    //   '1,7',
    //   '1,7'
    // );
    // setParticipants(list);

    closeDialog();
  };

  const handleBack = () => {
    if (currentPage === 3 && isAllSos > 0) return setCurrentPage(1);

    if (
      currentPage === 3 &&
      (parseInt(eventId) === 95 || parseInt(eventId) === 101)
    )
      return setCurrentPage(1);

    if (currentPage === 0) return handleCloseDialog();

    setCurrentPage((prev) => prev - 1);
  };

  const handleNext = async () => {
    // console.log(participants);
    const { valid, errMsg } = await isDataValid();
    if (valid === false) return alert(errMsg);

    //if (currentPage === 0) return setCurrentPage(2);
    if (currentPage === 1 && isAllSos > 0) return setCurrentPage(3);
    if (
      currentPage === 1 &&
      (parseInt(eventId) === 95 || parseInt(eventId) === 101)
    )
      return setCurrentPage(3);
    if (currentPage === 3)
      return goToSummary({
        email,
        team,
        participants,
        emergency,
      });

    setCurrentPage((prev) => prev + 1);
  };

  const getButtonBackText = () => {
    if (currentPage === 0) return isWHM ? 'Tutup' : 'Close';

    return isWHM ? 'Kembali' : 'Back';
  };

  const getButtonNextText = () => {
    if (currentPage === 3) return isWHM ? 'Ringkasan' : 'Summary';

    return isWHM ? 'Lanjut' : 'Next';
  };

  const isDataValid = async () => {
    let isDataValid = true;
    let errMsg = isWHM
      ? 'Ada kesalahan, periksa kembali form pendaftaran Anda.'
      : 'Something Wrong, Please check your form.';

    const teamUpdated = { ...team };
    if (currentPage === 0) {
      if (isGroup > 0) {
        if (team.name?.value === '') {
          teamUpdated.name.errorMessage = 'Team Name is required!';

          setTeam(teamUpdated);
          isDataValid = false;
        } else {
          const teamNameLength = team?.name?.value?.length || 0;
          if (teamNameLength > 15) {
            teamUpdated.name.errorMessage = 'Exceed maximal characters (15)';

            setTeam(teamUpdated);
            isDataValid = false;
          }
        }
      }

      const updated = { ...email };
      if (email.email?.value === '') {
        updated.email.errorMessage = isWHM
          ? 'Email tidak boleh kosong!'
          : 'Email is required!';

        setEmail(updated);
        isDataValid = false;
      } else {
        const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
          email.email?.value,
        );
        if (!isEmail) {
          updated.email.errorMessage = isWHM
            ? 'Email tidak valid!'
            : 'Email is not valid!';

          setEmail(updated);
          isDataValid = false;
        }
      }

      if (isDataValid === true && (eventId === 64 || eventId === 66)) {
        const { valid, alertMessage } = await isEmailLimitValid();
        if (valid === false) {
          isDataValid = false;
          errMsg = alertMessage;
        }
      }
    }

    // if (currentPage === 1) {
    //
    // }

    if (currentPage === 1) {
      const updated = [...participants];
      updated.forEach((p, index) => {
        // console.log('update peserta ke : ', index + 1);
        if (p.name?.value === '') {
          p.name.errorMessage = isWHM
            ? 'Nama tidak boleh kosong!'
            : 'Name is required!';
          isDataValid = false;
        }

        if (eventId === 85 || eventId === 86) {
          if (p.runningFor?.value.trim() !== '') {
            if (p.runningFor?.value.length > 12) {
              updated.runningFor.errorMessage = 'Input maximal 12 Characters.';
              isDataValid = false;
            }
          }

          if (p.runningFor?.value.trim() === '') {
            updated.runningFor.errorMessage = 'Input is Required!';
            isDataValid = false;
          }
        }

        if (p.gender?.value === '' && eventId !== 88) {
          p.gender.errorMessage = isWHM
            ? 'Jenis Kelamin tidak boleh Kosong!'
            : 'Gender is required!';
          isDataValid = false;
        }

        if (p.ageRange?.value === '' && (eventId === 95 || eventId === 101)) {
          p.ageRange.errorMessage = 'Age is required!';
          isDataValid = false;
        }

        if (p.parq1?.value === '' && (eventId === 95 || eventId === 101)) {
          p.parq1.errorMessage = 'Select One Options!';
          isDataValid = false;
        }

        if (p.parq2?.value === '' && (eventId === 95 || eventId === 101)) {
          p.parq2.errorMessage = 'Answer is required!';
          isDataValid = false;
        }

        if (p.parq3?.value === '' && (eventId === 95 || eventId === 101)) {
          p.parq3.errorMessage = 'Select an option required!';
          isDataValid = false;
        }

        if (
          p.nationality?.value === '' &&
          eventId !== 92 &&
          eventId !== 95 &&
          eventId !== 101
        ) {
          p.nationality.errorMessage = isWHM
            ? 'Kebangsaan tidak boleh kosong!'
            : 'Nationality is required!';
          isDataValid = false;
        }

        if (
          p.idType?.value === '' &&
          eventId !== 88 &&
          parseInt(eventId) !== 95 &&
          parseInt(eventId) !== 101
        ) {
          p.idType.errorMessage = isWHM
            ? 'Jenis Identitas tidak boleh Kosong!'
            : 'Id Type is required!';
          isDataValid = false;
        }

        if (
          p.idNumber?.value === '' &&
          eventId !== 88 &&
          parseInt(eventId) !== 95 &&
          parseInt(eventId) !== 101
        ) {
          p.idNumber.errorMessage = isWHM
            ? 'Nomor identitas tidak boleh kosong!'
            : 'Id Number is required!';
          isDataValid = false;
        }

        if (
          p.birthDate?.value !== '' &&
          eventId !== 88 &&
          eventId !== 95 &&
          eventId !== 101
        ) {
          // console.log(p.birthDate.value);
          const aMinAge = parseInt(adultMinAge);
          const aMaxAge = parseInt(adultMaxAge);

          const ageInMonth = dayjs().diff(dayjs(p.birthDate?.value), 'months');
          const age = Math.floor(ageInMonth / 12);
          // console.log(age);

          if (aMinAge > 0 && aMaxAge > 0) {
            if (age < aMinAge || age > aMaxAge) {
              if (age < aMinAge && maxAllowedDate) {
                // console.log('category id IN (146, 148)');
                const bedayUnix = dayjs(p.birthDate?.value).unix();
                // console.log('beday unix ', bedayUnix);
                const limitUnix = dayjs(maxAllowedDate).unix();
                // console.log('limit unix', limitUnix);
                const isBedayValid = bedayUnix <= limitUnix;
                // console.log('isBedayValid ', isBedayValid);
                if (!isBedayValid) {
                  p.birthDate.errorMessage = `Minimum age allowed is ${aMinAge}`;
                  isDataValid = false;
                }
              } else {
                p.birthDate.errorMessage = `Allowed age is between ${aMinAge} and ${aMaxAge}`;
                isDataValid = false;
              }
            }
          } else if (aMinAge > 0) {
            // console.log('minimal age used! ', aMinAge);
            if (age < aMinAge) {
              // console.log('max allowed date ', maxAllowedDate);
              // console.log('cat ID ', categoryId);

              if (maxAllowedDate) {
                // console.log('category id IN (146, 148)');
                const bedayUnix = dayjs(p.birthDate?.value).unix();
                // console.log('beday unix ', bedayUnix);
                const limitUnix = dayjs(maxAllowedDate).unix();
                // console.log('limit unix', limitUnix);
                const isBedayValid = bedayUnix <= limitUnix;
                // console.log('isBedayValid ', isBedayValid);
                if (!isBedayValid) {
                  p.birthDate.errorMessage = `Minimum age allowed is ${aMinAge}`;
                  isDataValid = false;
                }
              } else {
                //console.log('category id not valid');
                p.birthDate.errorMessage = `Minimum age allowed is ${aMinAge}`;
                isDataValid = false;
              }
            }
          }
        }

        if (
          p.birthDate?.value === '' &&
          eventId !== 88 &&
          eventId !== 95 &&
          eventId !== 101
        ) {
          p.birthDate.errorMessage = isWHM
            ? 'Tanggal Lahir tidak boleh kosong!'
            : 'Birthdate is required!';
          isDataValid = false;
        }

        if (
          p.bloodType?.value === '' &&
          eventId !== 88 &&
          parseInt(eventId) !== 95 &&
          parseInt(eventId) !== 101
        ) {
          p.bloodType.errorMessage = isWHM
            ? 'Golongan darah tidak boleh kosong!'
            : 'Blood Type is required!';
          isDataValid = false;
        }

        if (
          p.contact?.value === '' &&
          eventId !== 88 &&
          eventId &&
          eventId !== 101
        ) {
          p.contact.errorMessage = isWHM
            ? 'Kontak tidak boleh kosong!'
            : 'Phone Number is required!';
          isDataValid = false;
        }

        if (p.orgCom?.value === '') {
          const isOrgRequired = parseInt(eventId) === 92;

          if (isOrgRequired) {
            p.orgCom.errorMessage =
              eventId === 92
                ? 'User type is required!'
                : 'Organization / community is required!';
            isDataValid = false;
          }
        }

        if (
          p.prodi?.value === '' &&
          parseInt(eventId) === 92 &&
          p.orgCom?.value &&
          p.orgCom?.value !== '' &&
          p.orgCom?.value !== 'Umum'
        ) {
          p.prodi.errorMessage = 'Prodi is required!';
          isDataValid = false;
        }

        if (
          p.prodiYear?.value === '' &&
          eventId === 92 &&
          p.orgCom?.value &&
          p.orgCom?.value !== '' &&
          p.orgCom?.value !== 'Umum'
        ) {
          p.prodiYear.errorMessage = 'Year is required!';
          isDataValid = false;
        }

        // console.log('size index ke ', index + 1, ' ', p.size?.value);
        if (includeJersey > 0 && p.size?.value === '') {
          // console.log('value size kosong');
          // console.log('eventId ', eventId);
          // console.log('categoryId ', categoryId);
          // console.log('index ', index + 1);
          const isSizeRequired =
            parseInt(eventId) !== 77 ||
            (parseInt(categoryId) <= 203 && index + 1 < 3);

          // console.log('isRequired ', isSizeRequired);

          if (isSizeRequired) {
            p.size.errorMessage = isWHM
              ? 'Ukuran tidak boleh kosong!'
              : 'Size is required!';
            isDataValid = false;
          }
        }

        if (isAllSos > 0 && p.emergencyPerson?.value === '') {
          p.emergencyPerson.errorMessage = isWHM
            ? 'Nama tidak boleh kosong!'
            : 'Emergency Person is Required!';
          isDataValid = false;
        }

        if (isAllSos > 0 && p.emergencyContact?.value === '') {
          p.emergencyContact.errorMessage = isWHM
            ? 'Kontak tidak boleh kosong!'
            : 'Emergency Contact is Required!';
          isDataValid = false;
        }

        if (isAllSos > 0 && p.emergencyRelation?.value === '') {
          p.emergencyRelation.errorMessage = isWHM
            ? 'Hubungan tidak boleh kosong!'
            : 'Emergency Relation is Required!';
          isDataValid = false;
        }

        if (categoryId && categoryId === 168) {
          if (p.classType?.value === '') {
            p.classType.errorMessage = 'Category is required!';
            isDataValid = false;
          }
        }

        if (categoryId && (categoryId === 167 || categoryId === 174)) {
          if (p.tindakanoperasi?.value === '') {
            p.tindakanoperasi.errorMessage = 'Tindakan Operasi is required!';
            isDataValid = false;
          }
        }

        if (categoryId && (categoryId === 171 || categoryId === 177)) {
          if (p.npa?.value === '') {
            p.npa.errorMessage = 'No NPA is required!';
            isDataValid = false;
          }
        }

        if (eventId && (eventId === 64 || eventId === 66)) {
          if (p.street?.value === '') {
            p.street.errorMessage = 'Jalan is required!';
            isDataValid = false;
          }

          if (p.kelurahan?.value === '') {
            p.kelurahan.errorMessage = 'Kelurahan is required!';
            isDataValid = false;
          }

          if (p.kecamatan?.value === '') {
            p.kecamatan.errorMessage = 'Kecamatan is required!';
            isDataValid = false;
          }

          if (p.kota?.value === '') {
            p.kota.errorMessage = 'Kota is required!';
            isDataValid = false;
          }

          if (p.kodepos?.value === '') {
            p.kodepos.errorMessage = 'Kode Pos is required!';
            isDataValid = false;
          }
        }
      });

      setParticipants(updated);

      if (isDataValid === true) {
        const { valid, alertMessage } = await isSizeLimitValid();
        if (valid === false) {
          isDataValid = false;
          errMsg = alertMessage;
        }
      }
    }

    if (currentPage === 2) {
      const updated = { ...emergency };
      if (emergency.person?.value === '') {
        updated.person.errorMessage = isWHM
          ? 'Nama tidak boleh Kosong!'
          : 'Person Name is Required!';
        isDataValid = false;
      }

      if (emergency.contact?.value === '') {
        updated.contact.errorMessage = isWHM
          ? 'Kotak tidak boleh kosong!'
          : 'Person Contact is Required!';
        isDataValid = false;
      }

      if (emergency.relation?.value === '' && eventId !== 88) {
        updated.relation.errorMessage = isWHM
          ? 'Hubungan tidak boleh kosong!'
          : 'Person Relation is Required!';
        isDataValid = false;
      }

      if (eventId === 90 || eventId === 91) {
        if (emergency.parq1?.value === '') {
          updated.parq1.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq2?.value === '') {
          updated.parq2.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq3?.value === '') {
          updated.parq3.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq4?.value === '') {
          updated.parq4.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq5?.value === '') {
          updated.parq5.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq6?.value === '') {
          updated.parq6.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        if (emergency.parq7?.value === '') {
          updated.parq7.errorMessage = isWHM
            ? 'Kuisoner harus di jawab!'
            : 'Questioner answer is Required!';
          isDataValid = false;
        }

        // if (emergency.parq8?.value === '') {
        //   updated.parq8.errorMessage = 'Questioner answer is Required!';
        //   isDataValid = false;
        // }
      }

      setEmergency(updated);
    }

    return { valid: isDataValid, errMsg };
  };

  const isSizeLimitValid = async () => {
    if (sizesInfo.length === 0 || includeJersey === 0)
      return { valid: true, alertMessage: 'ok' };

    const data = [...participants];

    const sizes = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      const isFoundIdx = sizes.findIndex(
        (s) => s?.size === element?.size?.value,
      );

      // console.log('is size limit valid, isFound ', isFoundIdx);

      if (isFoundIdx < 0) {
        sizes.push({ size: element.size.value, sizeCount: 1 });
      } else {
        sizes[isFoundIdx].sizeCount++;
      }
    }
    // console.log('is size limit valid ', sizes);
    try {
      setCheckLimitLoad(true);
      const { data } = await api.post('/size/checklimit', {
        eventId,
        sizes,
      });

      setCheckLimitLoad(false);
      // console.log(result);
      if (data.isValid === false)
        return { valid: false, alertMessage: data.message };

      return { valid: true, alertMessage: 'ok' };
    } catch (error) {
      setCheckLimitLoad(false);
      return { valid: false, alertMessage: error.message };
    }
  };

  const isEmailLimitValid = async () => {
    try {
      setCheckLimitLoad(true);
      const { data } = await api.post('/events/email/limit', {
        eventId,
        email: email?.email?.value,
      });

      setCheckLimitLoad(false);
      // console.log(result);
      if (data.isValid === false)
        return { valid: false, alertMessage: data.message };

      return { valid: true, alertMessage: 'ok' };
    } catch (error) {
      setCheckLimitLoad(false);
      return { valid: false, alertMessage: error.message };
    }
  };

  return (
    <Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={showDialog}
        aria-labelledby="responsive-dialog-title"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: !fullScreen ? '768px' : '100%', // Set your width here
            },
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          {isWHM ? 'Tambah Detail Tiket' : 'Add detail Ticket'}
        </DialogTitle>
        <DialogContent ref={dialogContentRef}>
          {currentPage === 0 && (
            <Grid container style={classes.containerSpaceAround}>
              <Grid item xs={12} sm={6}>
                <DialogContentText align="center">Email</DialogContentText>
                <Box
                  component={'form'}
                  noValidate
                  autoComplete="off"
                  sx={{ m: 1 }}
                >
                  {/* email */}
                  <FormTextField
                    index={40}
                    i={0}
                    required
                    label={'Email'}
                    errorMessage={email?.email?.errorMessage}
                    value={email?.email?.value}
                    onChange={(e) =>
                      handleEmailChange(e.target?.value, 'email')
                    }
                  />
                  <Typography
                    variant="subtitle2"
                    color={'CaptionText'}
                    sx={{ marginTop: '-10px', marginBottom: '20px' }}
                  >
                    Mohon pastikan alamat email yang Anda masukkan sudah benar.
                    Email Konfirmasi Pembayaran/E-Tiket akan dikirim ke alamat
                    tersebut dan menjadi bukti resmi untuk pengambilan Race Kit
                    saat Race Pack Collection (RPC).
                    {/* Please ensure you enter your email address correctly to
                    receive a Payment Confirmation Email/E-Ticket. This serves
                    as proof of valid Racekit collection during the RPC. */}
                    {eventId === 64 || eventId === 66
                      ? ' 1 alamat email hanya untuk 1 peserta.'
                      : ''}
                  </Typography>

                  {/* team name */}
                  {isGroup > 0 && (
                    <>
                      <FormTextField
                        index={41}
                        i={0}
                        required
                        label={'Team Name'}
                        errorMessage={team?.name?.errorMessage}
                        value={team?.name?.value}
                        onChange={(e) =>
                          handleTeamNameChange(e.target?.value, 'name')
                        }
                      />

                      <Typography
                        variant="subtitle2"
                        color={'CaptionText'}
                        sx={{ marginTop: '-10px' }}
                      >
                        Isi Nama Group/Team dengan benar, karna akan tercetak
                        pada BIB anda. (Max 15 character)
                      </Typography>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          )}

          {/* {currentPage === 1 && (
            <Grid container style={classes.containerSpaceAround}>
              <Grid item xs={12} sm={6}>
                <DialogContentText align="center">Team</DialogContentText>
                <Box
                  component={'form'}
                  noValidate
                  autoComplete="off"
                  sx={{ m: 1 }}
                ></Box>
              </Grid>
            </Grid>
          )} */}

          {currentPage === 1 && (
            <Grid container style={classes.containerSpaceAround}>
              {participants.map((p, idx) => {
                const hideJersey =
                  eventId === 77 && categoryId > 203 && idx + 1 > 2;

                return (
                  <Grid key={idx} item xs={12} sm={6}>
                    <DialogContentText align="center">
                      {eventId === 88 ? 'Peserta' : `Peserta ${idx + 1}`}
                    </DialogContentText>
                    <Box
                      component={'form'}
                      noValidate
                      autoComplete="off"
                      sx={{ m: 1 }}
                    >
                      {/* name */}
                      <FormTextField
                        index={0}
                        i={idx}
                        required
                        label={getFormLabel(eventId).name}
                        errorMessage={p.name?.errorMessage}
                        value={p.name?.value}
                        onChange={(e) =>
                          handleDataChange(e.target?.value, 'name', idx)
                        }
                      />

                      {/* running for */}
                      {(eventId === 85 || eventId === 86) && (
                        <>
                          <Box
                            display="flex"
                            flexDirection={'row'}
                            justifyContent="space-between"
                            marginBottom={'6px'}
                          >
                            <Typography
                              variant="subtitle2"
                              color={'CaptionText'}
                            >
                              *Please fill in a name or initials, max 12
                              characters.
                            </Typography>
                            <Typography
                              variant="body2"
                              color={`${
                                p?.runningFor?.value?.length > 12
                                  ? 'red'
                                  : 'CaptionText'
                              }`}
                            >
                              {`${
                                p?.runningFor?.value?.length?.toString() || '0'
                              }/12`}
                            </Typography>
                          </Box>
                          <FormTextField
                            index={37}
                            i={0}
                            required
                            label={`I'm running for (printed on BIB) `}
                            errorMessage={p?.runningFor?.errorMessage}
                            value={p?.runningFor?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'runningFor',
                                idx,
                              )
                            }
                          />
                        </>
                      )}

                      {/* gender */}
                      {eventId !== 88 && (
                        <FormTextField
                          index={1}
                          i={idx}
                          required
                          type={'select'}
                          label={getFormLabel(eventId).gender}
                          selectOpts={genderRange}
                          errorMessage={p.gender?.errorMessage}
                          value={p.gender?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'gender', idx)
                          }
                        />
                      )}

                      {(eventId === 95 || eventId === 101) && (
                        <FormTextField
                          index={1}
                          i={idx}
                          required
                          type={'select'}
                          label={getFormLabel(eventId).ageRange}
                          selectOpts={ageRangeOpts}
                          errorMessage={p.ageRange?.errorMessage}
                          value={p.ageRange?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'ageRange', idx)
                          }
                        />
                      )}

                      {(eventId === 95 || eventId === 101) && (
                        <>
                          <Typography marginBottom={2}>
                            Apakah kamu minum Kratindaeng Red Bull?
                          </Typography>
                          <FormTextField
                            index={1}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).parq}
                            selectOpts={parqYesNo}
                            errorMessage={p.parq1?.errorMessage}
                            value={p.parq1?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'parq1', idx)
                            }
                          />
                        </>
                      )}

                      {(eventId === 95 || eventId === 101) && (
                        <>
                          <Typography marginBottom={2}>
                            Tahu event Kratindaeng Red Bull Power Race dari
                            mana?
                          </Typography>
                          <FormTextField
                            index={4}
                            i={idx}
                            required
                            label={getFormLabel(eventId).answer}
                            errorMessage={p.parq2?.errorMessage}
                            value={p.parq2?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'parq2', idx)
                            }
                          />
                        </>
                      )}

                      {(eventId === 95 || eventId === 101) && (
                        <>
                          <Typography marginBottom={2}>
                            Rencana kalian akan nonton apa?
                          </Typography>
                          <FormTextField
                            index={1}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).acara}
                            selectOpts={[
                              { name: 'Race' },
                              { name: 'Konser' },
                              { name: 'Semuanya' },
                            ]}
                            errorMessage={p.parq3?.errorMessage}
                            value={p.parq3?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'parq3', idx)
                            }
                          />
                        </>
                      )}

                      {/* nationality */}
                      {eventId !== 92 && eventId !== 95 && eventId !== 101 && (
                        <FormTextField
                          index={2}
                          i={idx}
                          required
                          type={'select'}
                          label={getFormLabel(eventId).nationality}
                          selectOpts={countryOptions}
                          errorMessage={p.nationality?.errorMessage}
                          value={p.nationality?.value}
                          onChange={(e) =>
                            handleDataChange(
                              e.target?.value,
                              'nationality',
                              idx,
                            )
                          }
                        />
                      )}
                      {/* id type */}
                      {eventId !== 88 &&
                        parseInt(eventId) !== 95 &&
                        eventId !== 101 && (
                          <FormTextField
                            index={3}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).idType}
                            selectOpts={
                              parseInt(eventId) !== 92
                                ? idTypeCats
                                : idTypeCatsDomestic
                            }
                            errorMessage={p.idType?.errorMessage}
                            value={p.idType?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'idType', idx)
                            }
                          />
                        )}
                      {/* id number */}
                      {eventId !== 88 &&
                        parseInt(eventId) !== 95 &&
                        eventId !== 101 && (
                          <FormTextField
                            index={4}
                            i={idx}
                            required
                            label={getFormLabel(eventId).idNumber}
                            errorMessage={p.idNumber?.errorMessage}
                            value={p.idNumber?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'idNumber', idx)
                            }
                          />
                        )}

                      {/* event shom Alamat */}
                      {eventId && (eventId === 64 || eventId === 66) && (
                        <>
                          <FormTextField
                            index={14}
                            i={idx}
                            required
                            label={'Alamat'}
                            errorMessage={p.street?.errorMessage}
                            value={p.street?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'street', idx)
                            }
                          />
                          <FormTextField
                            index={15}
                            i={idx}
                            required
                            label={'Kelurahan'}
                            errorMessage={p.kelurahan?.errorMessage}
                            value={p.kelurahan?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'kelurahan',
                                idx,
                              )
                            }
                          />
                          <FormTextField
                            index={16}
                            i={idx}
                            required
                            label={'Kecamatan'}
                            errorMessage={p.kecamatan?.errorMessage}
                            value={p.kecamatan?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'kecamatan',
                                idx,
                              )
                            }
                          />
                          <FormTextField
                            index={17}
                            i={idx}
                            required
                            label={'Kota'}
                            errorMessage={p.kota?.errorMessage}
                            value={p.kota?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'kota', idx)
                            }
                          />
                          <FormTextField
                            index={18}
                            i={idx}
                            required
                            label={'Kode Pos'}
                            errorMessage={p.kodepos?.errorMessage}
                            value={p.kodepos?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'kodepos', idx)
                            }
                          />
                        </>
                      )}

                      {categoryId &&
                        (categoryId === 167 || categoryId === 174) && (
                          <FormTextField
                            index={19}
                            i={idx}
                            required
                            label={'Tindakan Operasi, Tanggal, RS'}
                            errorMessage={p.tindakanoperasi?.errorMessage}
                            value={p.tindakanoperasi?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'tindakanoperasi',
                                idx,
                              )
                            }
                          />
                        )}

                      {categoryId &&
                        (categoryId === 171 || categoryId === 177) && (
                          <FormTextField
                            index={20}
                            i={idx}
                            required
                            label={'No NPA'}
                            errorMessage={p.npa?.errorMessage}
                            value={p.npa?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'npa', idx)
                            }
                          />
                        )}
                      {/* birth date */}
                      {eventId !== 88 && eventId !== 95 && eventId !== 101 && (
                        <FormTextField
                          index={5}
                          i={idx}
                          required
                          type={'date'}
                          label={getFormLabel(eventId).birthDate}
                          errorMessage={p.birthDate?.errorMessage}
                          value={p.birthDate?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'birthDate', idx)
                          }
                        />
                      )}
                      {/* blood type */}
                      {eventId !== 88 &&
                        parseInt(eventId) !== 95 &&
                        eventId !== 101 && (
                          <FormTextField
                            index={6}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).bloodType}
                            selectOpts={bloodTypeOptions}
                            errorMessage={p.bloodType?.errorMessage}
                            value={p.bloodType?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'bloodType',
                                idx,
                              )
                            }
                          />
                        )}
                      {/* contact */}
                      {eventId !== 88 && eventId !== 95 && eventId !== 101 && (
                        <FormTextField
                          index={7}
                          i={idx}
                          required
                          label={getFormLabel(eventId).phoneNumber}
                          errorMessage={p?.contact?.errorMessage}
                          value={p?.contact?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'contact', idx)
                          }
                        />
                      )}
                      {/* organization */}
                      {eventId !== 92 && eventId !== 95 && eventId !== 101 && (
                        <FormTextField
                          index={8}
                          i={idx}
                          label={
                            eventId === 88
                              ? 'Institution'
                              : getFormLabel(eventId).org
                          }
                          errorMessage={p.orgCom?.errorMessage}
                          value={p.orgCom?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'orgCom', idx)
                          }
                        />
                      )}

                      {/* humaniorun fib */}
                      {eventId === 92 && (
                        <>
                          <FormTextField
                            index={51}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).status}
                            selectOpts={userTypeOptions}
                            errorMessage={p.orgCom?.errorMessage}
                            value={p.orgCom?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'orgCom', idx)
                            }
                          />

                          {p.orgCom.value &&
                            p.orgCom.value !== '' &&
                            p.orgCom.value !== 'Umum' && (
                              <>
                                <FormTextField
                                  index={52}
                                  i={idx}
                                  required
                                  type={'select'}
                                  label={getFormLabel(eventId).prodi}
                                  selectOpts={prodiOptions}
                                  errorMessage={p.prodi?.errorMessage}
                                  value={p.prodi?.value}
                                  onChange={(e) =>
                                    handleDataChange(
                                      e.target?.value,
                                      'prodi',
                                      idx,
                                    )
                                  }
                                />

                                <FormTextField
                                  index={53}
                                  i={idx}
                                  required
                                  type={'select'}
                                  label={getFormLabel(eventId).year}
                                  selectOpts={yearOptions.reverse()}
                                  errorMessage={p.prodiYear?.errorMessage}
                                  value={p.prodiYear?.value}
                                  onChange={(e) =>
                                    handleDataChange(
                                      e.target?.value,
                                      'prodiYear',
                                      idx,
                                    )
                                  }
                                />
                              </>
                            )}
                        </>
                      )}

                      {/* size */}
                      {includeJersey > 0 && !hideJersey && (
                        <>
                          {eventId !== 92 && sizeChartUrl && (
                            <Button
                              sx={{ paddingTop: 0, marginTop: '-5px' }}
                              onClick={() => setShowSizeChart((prev) => !prev)}
                            >
                              {isWHM ? 'Panduan Ukuran' : 'Size Chart'}
                            </Button>
                          )}
                          <FormTextField
                            eventId={eventId}
                            index={9}
                            i={idx}
                            required
                            type={'select'}
                            label={getFormLabel(eventId).size}
                            selectOpts={p?.sizeRange}
                            errorMessage={p.size?.errorMessage}
                            value={p.size?.value}
                            onChange={(e) =>
                              handleDataChange(e.target?.value, 'size', idx)
                            }
                          />

                          {eventId === 92 && (
                            <Box
                              sx={{
                                backgroundColor: 'red',
                                width: '100%',
                              }}
                            >
                              <img
                                style={{ width: '100%' }}
                                src={sizeChartUrl}
                                alt={'size-chart'}
                              />
                            </Box>
                          )}
                        </>
                      )}

                      {isAllSos > 0 && (
                        <>
                          {/* name */}
                          <FormTextField
                            index={10}
                            i={idx}
                            required
                            label={isWHM ? 'Nama' : 'Emergency Person'}
                            errorMessage={p?.emergencyPerson?.errorMessage}
                            value={p?.emergencyPerson?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'emergencyPerson',
                                idx,
                              )
                            }
                          />

                          {/* contact */}
                          <FormTextField
                            index={11}
                            i={idx}
                            required
                            label={isWHM ? 'Kontak' : 'Emergency Phone Number'}
                            errorMessage={p?.emergencyContact?.errorMessage}
                            value={p?.emergencyContact?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'emergencyContact',
                                idx,
                              )
                            }
                          />
                          {/* Relation */}
                          <FormTextField
                            index={12}
                            i={idx}
                            required
                            type={'select'}
                            label={isWHM ? 'Hubungan' : 'Emergency Relation'}
                            selectOpts={relationOptions}
                            errorMessage={p?.emergencyRelation?.errorMessage}
                            value={p?.emergencyRelation?.value}
                            onChange={(e) =>
                              handleDataChange(
                                e.target?.value,
                                'emergencyRelation',
                                idx,
                              )
                            }
                          />
                        </>
                      )}
                      {categoryId && categoryId === 168 && (
                        <FormTextField
                          index={13}
                          i={idx}
                          required
                          type={'select'}
                          label={'Category'}
                          selectOpts={classTypeOptions}
                          errorMessage={p.classType?.errorMessage}
                          value={p.classType?.value}
                          onChange={(e) =>
                            handleDataChange(e.target?.value, 'classType', idx)
                          }
                        />
                      )}

                      {eventId === 88 && (
                        <Typography
                          variant="subtitle2"
                          color={'CaptionText'}
                          sx={{ marginTop: '-10px', marginBottom: '20px' }}
                        >
                          Data Protection: Personal data collected will be used
                          exclusively for purposes related to this event and
                          handled in accordance with applicable{' '}
                          <Link
                            component="a"
                            href="https://www.eeas.europa.eu/eeas/data-protection_en?s=168"
                            target="_blank"
                            rel="noopener"
                            underline="hover"
                          >
                            data protection regulations
                          </Link>
                          {'.'}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}

          {currentPage === 2 && (
            <Grid container style={classes.containerSpaceAround}>
              <Grid item xs={12} sm={6}>
                <DialogContentText align="center">
                  {isWHM ? 'Informasi Kontak Darurat' : 'Emergency Person'}
                </DialogContentText>
                <Box
                  component={'form'}
                  noValidate
                  autoComplete="off"
                  sx={{ m: 1 }}
                >
                  {/* name */}
                  <FormTextField
                    index={31}
                    i={0}
                    required
                    label={getFormLabel(eventId).emgPerson}
                    errorMessage={emergency?.person?.errorMessage}
                    value={emergency?.person?.value}
                    onChange={(e) =>
                      handleEmergencyDataChange(e.target?.value, 'person')
                    }
                  />

                  {/* contact */}
                  <FormTextField
                    index={32}
                    i={0}
                    required
                    label={getFormLabel(eventId).emgContact}
                    errorMessage={emergency?.contact?.errorMessage}
                    value={emergency?.contact?.value}
                    onChange={(e) =>
                      handleEmergencyDataChange(e.target?.value, 'contact')
                    }
                  />
                  {/* Relation */}
                  {eventId !== 88 && (
                    <FormTextField
                      index={33}
                      i={0}
                      required
                      type={'select'}
                      label={getFormLabel(eventId).emgRelation}
                      selectOpts={relationOptions}
                      errorMessage={emergency?.relation?.errorMessage}
                      value={emergency?.relation?.value}
                      onChange={(e) =>
                        handleEmergencyDataChange(e.target?.value, 'relation')
                      }
                    />
                  )}
                </Box>

                {eventId === 90 || eventId === 91 ? (
                  <>
                    <DialogContentText
                      align="center"
                      fontWeight={700}
                      color={'#313131'}
                      marginBottom={1}
                      marginTop={2}
                    >
                      Pre-Event Health Screening
                    </DialogContentText>
                    <DialogContentText>
                      Mohon mengisi daftar pertanyaan di bawah ini untuk
                      skrining kesehatan fisik dan jiwa serta identifikasi
                      kebutuhan dukungan yang diperlukan nanti saat race
                      berlangsung.Apabila Anda menjawab "Ya" pada pertanyaan
                      tertentu atau memiliki keraguan mengenai kondisi kesehatan
                      Anda, kami menganjurkan untuk berkonsultasi dengan tenaga
                      kesehatan sebelum mengikuti acara.
                    </DialogContentText>

                    <Box
                      component={'form'}
                      noValidate
                      autoComplete="off"
                      sx={{ m: 1 }}
                    >
                      <DialogContentText marginBottom={1} marginTop={1}>
                        Kesehatan Fisik :
                      </DialogContentText>
                      {/* parq1 */}
                      <>
                        1. Apakah sebelum ini dokter pernah menyatakan bahwa
                        anda memiliki gangguan jantung dan karenanya anda hanya
                        boleh melakukan aktivitas fisik yang direkomendasikan
                        dokter?
                        <FormTextField
                          index={34}
                          i={1}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq1?.errorMessage}
                          value={emergency?.parq1?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq1')
                          }
                        />
                      </>

                      {/* parq2 */}
                      <>
                        2.Apakah saat ini Anda mengalami salah satu dari kondisi
                        berikut? Nyeri dada saat beraktivitas Sesak napas yang
                        tidak biasa Pusing atau pernah pingsan saat berolahraga
                        <FormTextField
                          index={35}
                          i={2}
                          x
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq2?.errorMessage}
                          value={emergency?.parq2?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq2')
                          }
                        />
                      </>

                      {/* parq3 */}
                      <>
                        3. Apakah Anda merasa cukup sehat untuk mengikuti
                        kegiatan lari sesuai kategori yang Anda daftarkan?
                        <FormTextField
                          index={36}
                          i={3}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq3?.errorMessage}
                          value={emergency?.parq3?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq3')
                          }
                        />
                      </>

                      <DialogContentText marginBottom={1} marginTop={1}>
                        Kesehatan Jiwa :
                      </DialogContentText>
                      {/* parq4 */}
                      <>
                        1.⁠ ⁠Saya kadang merasa kurang nyaman di tempat yang
                        ramai, panas, atau berisik.
                        <FormTextField
                          index={37}
                          i={4}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq4?.errorMessage}
                          value={emergency?.parq4?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq4')
                          }
                        />
                      </>

                      {/* parq5 */}
                      <>
                        2.⁠ ⁠Saya kadang membutuhkan waktu lebih untuk fokus,
                        memahami arahan, atau menenangkan diri.
                        <FormTextField
                          index={38}
                          i={5}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq5?.errorMessage}
                          value={emergency?.parq5?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq5')
                          }
                        />
                      </>

                      {/* parq6 */}
                      <>
                        3.⁠ ⁠Saya kadang merasa kurang fit karena suasana hati
                        sedang tidak baik, gelisah, atau tidur kurang.
                        <FormTextField
                          index={39}
                          i={6}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq6?.errorMessage}
                          value={emergency?.parq6?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq6')
                          }
                        />
                      </>

                      {/* parq7 */}
                      <>
                        4.⁠ ⁠Saya kadang merasa perlu ditemani atau dibantu
                        untuk merasa lebih nyaman dan aman selama berkegiatan.
                        <FormTextField
                          index={40}
                          i={7}
                          required
                          type={'select'}
                          label={'Ya/Tidak'}
                          selectOpts={healthAnswerOptions}
                          errorMessage={emergency?.parq7?.errorMessage}
                          value={emergency?.parq7?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq7')
                          }
                        />
                      </>

                      {/* parq8 */}
                      {/* <>
                        Apakah anda mengetahui ada alasan lain sehingga anda
                        sebaiknya tidak melakukan aktivitas fisik?
                        <FormTextField
                          index={41} 
                          i={8}
                          required
                          type={'select'}
                          label={'Tidak/Ragu-ragu/Ya'}
                          selectOpts={parqAnswersOptions}
                          errorMessage={emergency?.parq8?.errorMessage}
                          value={emergency?.parq8?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq8')
                          }
                        />
                      </> */}
                    </Box>
                  </>
                ) : null}

                {eventId === 93 || eventId === 94 ? (
                  <>
                    <DialogContentText
                      align="center"
                      fontWeight={700}
                      color={'#313131'}
                      marginBottom={1}
                      marginTop={2}
                    >
                      Questioner:
                    </DialogContentText>
                    {/* <DialogContentText>
                      Mohon mengisi daftar pertanyaan di bawah ini untuk
                      skrining kesehatan fisik dan jiwa serta identifikasi
                      kebutuhan dukungan yang diperlukan nanti saat race
                      berlangsung.Apabila Anda menjawab "Ya" pada pertanyaan
                      tertentu atau memiliki keraguan mengenai kondisi kesehatan
                      Anda, kami menganjurkan untuk berkonsultasi dengan tenaga
                      kesehatan sebelum mengikuti acara.
                    </DialogContentText> */}

                    <Box
                      component={'form'}
                      noValidate
                      autoComplete="off"
                      sx={{ m: 1 }}
                    >
                      {/* parq1 */}
                      <>
                        1.⁠ ⁠Apakah kamu mengetahui Event Red Bull Power Race
                        sebelumnya?
                        <FormTextField
                          index={34}
                          i={1}
                          required
                          type={'select'}
                          label={'Tahu/Tidak Tahu'}
                          selectOpts={redBullParq1}
                          errorMessage={emergency?.parq1?.errorMessage}
                          value={emergency?.parq1?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq1')
                          }
                        />
                      </>

                      {/* parq2 */}
                      <>
                        2.⁠ ⁠⁠Apakah kamu sudah mendaftar event Red Bull Power
                        Race?
                        <FormTextField
                          index={35}
                          i={2}
                          required
                          type={'select'}
                          label={'Sudah/Belum'}
                          selectOpts={redBullParq2}
                          errorMessage={emergency?.parq2?.errorMessage}
                          value={emergency?.parq2?.value}
                          onChange={(e) =>
                            handleEmergencyDataChange(e.target?.value, 'parq2')
                          }
                        />
                      </>
                    </Box>
                  </>
                ) : null}
              </Grid>
            </Grid>
          )}

          {currentPage === 3 && (
            <DialogContentText>
              {isWHM
                ? 'Apakah data yang Anda masukkan sudah benar?Pastikan semua data yang Anda masukkan sudah benar. Jika Anda meninggalkan halaman ini, semua data yang telah diisi akan dihapus dan Anda harus mengisinya kembali.'
                : 'Is the data correct? Make sure the data you enter is correct. Your data will be reset after leaving this page.'}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleBack} disabled={checkLimitLoad}>
            {getButtonBackText()}
          </Button>
          <LoadingButton
            onClick={handleNext}
            autoFocus
            loading={checkLimitLoad}
          >
            {getButtonNextText()}
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog open={showSizeChart}>
        <img src={sizeChartUrl} alt={'size-chart'} />
        <DialogActions>
          <Button onClick={() => setShowSizeChart((prev) => !prev)}>
            Back
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DetailParticipants;
